import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
import { SELF_DEFENSE_WHAT_YOU_LEARN } from './selfDefenseContent';
export function SelfDefenseWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-3039">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3040">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3041">
          <div data-id="element-3042">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-3043">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-3044">
              {SELF_DEFENSE_WHAT_YOU_LEARN.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-3045">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-3046" />
                  <span data-id="element-3047">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-3048">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-3049">
                Ask About Self-Defense Classes
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-3050">
            <img src={SITE_IMAGES.selfDefense} alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-3051" />
          </div>
        </div>
      </div>
    </section>;
}